module.exports = __webpack_public_path__ + "static/media/razbijena-casa-2.6f592090.svg";